import React, {useCallback, useRef, useState} from 'react';
import {Alert, Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row} from "reactstrap5";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import standa from "../../../images-cp/standa.svg"

const StudentModal = ({afterClose, config}) => {

    const form = useRef(null);
    const [showForm, setShowForm] = useState(false);
    const [sent, setSent] = useState(false);

    const onSubmit = useCallback((e) => {

        if (e) {
            e.preventDefault();
        }

        let data = {
            email: form.current.elements['email'].value,
        }

        const body = new URLSearchParams(data);

        fetch(config.inviteParentUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body.toString(),
        }).finally((response) => setSent(true));
    }, [form, config, setSent]);

    return (
        <Modal isOpen={true} toggle={afterClose} fade={true} centered={true} size="lg" contentClassName="rounded-20">
            <ModalHeader tag="div" toggle={afterClose} className="align-items-start">
                <div className="d-flex align-content-center">
                    <h1 className="modal-title text-22 text-start my-auto">
                        <FormattedMessage defaultMessage="Dál to nepůjde :("/>
                    </h1>
                </div>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs={12} lg={6} className="text-center">
                        <img src={standa} />
                    </Col>
                    <Col xs={12} lg={6} className="text-center pe-5 pt-5">
                        <h2 className="text-center text-18">
                            <FormattedMessage defaultMessage="Je nám líto, ale Školu s{nbsp}nadhledem PREMIUM mohou objednávat jen rodiče a učitelé." values={{ nbsp: <React.Fragment>&nbsp;</React.Fragment> }}/>
                        </h2>
                        <p className="mt-3 text-14 ps-2 mb-4 text-center">
                            <FormattedMessage
                                defaultMessage="Můžeš poprosit rodiče, aby ti licenci koupil. Stojí pár korun na rok a budeš moci využít všechny vychytávky, které jsme pro tebe připravili."/>
                        </p>
                        {!showForm && <Button color="-blue" className="btn--bolder mb-3" onClick={() => setShowForm(true)}>
                            <FormattedMessage defaultMessage="Pošli odkaz rodičům"/>
                        </Button>}

                        {showForm && !sent && <Form innerRef={form} onSubmit={onSubmit}>
                            <FormGroup>
                                <Label for="email" className="fw-bold">
                                    <FormattedMessage defaultMessage="Email rodiče:"/>
                                </Label>
                                <Input type="email" name="email" required />
                            </FormGroup>
                            <Button color="-blue" className="btn--bolder mb-3" type="submit">
                                <FormattedMessage defaultMessage="Odeslat"/>
                            </Button>
                        </Form>}

                        {showForm && sent && <Alert color="primary">
                             <FormattedMessage defaultMessage="E-Mail byl rodiči odeslán" />
                        </Alert>}
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );

};

StudentModal.propTypes = {
    afterClose: PropTypes.func.isRequired,
    config: PropTypes.object.isRequired
};

StudentModal.defaultProps = {}

export default StudentModal;
